export function getLayerValue(layer: any, field: any) {
    const key = field.default_value_from_layer_key;
    if (!key) return undefined;
    return layer?.[key];
}
